<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <!--ENREGISTRER UN PRESENCE -->
    <!-- <v-layout row> -->
      <!-- <v-flex xs12 ml-2 mr-2> -->
        <v-card>
          <!-- <v-flex xs12 class="mb-2 ml-2 mr-2">
            <v-alert
              :value="true"
              outline
              color="purple"
              icon="info"
            >Liste des ressources techniques affectés à une tache concernant ce lot de travaux</v-alert>
          </v-flex> -->
          <el-form
            id="prestataireSelect"
            label-position="top"
            :inline="true"
            :model="prestataireSelect"
            :ref="prestataireSelect"
            class="demo-form-inline"
          >
            <v-layout row>
              <v-flex md3>
                <el-form-item label="Nom" prop="nom">
                  <el-select
                    filterable
                    style="width:100%"
                    v-model="prestataireSelect.id"
                    placeholder="Select"
                    @change="handleChangeOuvrier()"
                  >
                    <el-option
                      v-for="(item, index) in listeOuvriers"
                      :key="index"
                      :label="item.nom"
                      :value="item"
                    >
                     <span style="float: left">{{ item.nom }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.profession }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </v-flex>

              <v-flex md3>
                <el-form-item label="Contrat" required>
                  <el-select   filterable   default-first-option v-model="prestataireSelect.contrat" placeholder="Selectionnez le contrat" style="width:100%">
                    <el-option v-for="(item,index) in listeContratOuvrier" :key="index" :label="item.libTache" :value="item">
                      <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.libTache }}</span> -->
                      <span style="float: left">{{  item.libTache }}</span>
                    <span class="m-2" style="float: right; color: #8492a6; font-size: 13px"> (Tache   {{ item.tache }})</span>

                    </el-option>
                  </el-select>
                </el-form-item>
              </v-flex>

                <v-flex md3>
                     <el-form-item label="Type de travailleur" required>
                        <el-select name="valeurSelect" id="valeurSelect"  v-model="prestataireSelect.type"  placeholder="Type de travailleur" style="width:100%">
                            <el-option v-for="item in typeTravaiL" :key="item.value" :label="item.text" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </v-flex>

                <v-flex md3>
                  <el-form-item label="Heure supplémentaire"  required >
                      <el-select name="valeurheureSupp" id="valeurheureSupp"  v-model="prestataireSelect.heurSUpp"  placeholder="Heure supplémentaire" style="width:100%">
                          <el-option v-for="item in heurSUpp" :key="item.value" :label="item.text" :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </v-flex>

            </v-layout>

            <v-layout row v-if="this.prestataireSelect.type == 1" >
               <v-flex md3>
                <el-form-item label="Heure Début" required style="width:50%">
                  <el-time-select
                    v-model="prestataireSelect.heureDbt"
                    @change="calculTotalComm()"
                    :picker-options="{
                        start: '06:00',
                        step: '00:15',
                        end: '18:00'
                    }"
                    placeholder="Heure debut "
                  ></el-time-select>
                </el-form-item>
              </v-flex>

                <v-flex md3>
                <el-form-item label="Heure Fin" style="width:50%" required>
                  <el-time-select
                    v-model="prestataireSelect.heureFin"
                    @change="calculTotalComm()"
                    :picker-options="{
                         start: '06:00',
                        step: '00:15',
                        end: '18:00'
                    }"
                    placeholder="Heure fin "
                  ></el-time-select>
                </el-form-item>
              </v-flex>

                <v-flex md3>
                  <el-form-item label="Heure Pause" style="width:50%" required>
                    <el-time-select
                      v-model="prestataireSelect.heurePause"
                      @change="calculTotalComm()"
                      :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '10:00'
                      }"
                      placeholder="Heure de pause "
                    ></el-time-select>
                  </el-form-item>
                </v-flex>

                  <v-flex md3>
                    <el-form-item label="Heure Intenperie" style="width:50%" required>
                      <el-time-select
                        v-model="prestataireSelect.heureIntem"
                        @change="calculTotalComm()"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '10:00'
                        }"
                        placeholder="Heure Intempéries "
                      ></el-time-select>
                    </el-form-item>
                  </v-flex>
                  <v-flex md3>
                    <el-form-item label="Total travail" style="width:100%" required>
                      <el-input  class="inline-input" v-model="prestataireSelect.heureTotal" required  :placeholder="this.totalHeureOuvrier" :readonly="true" style="width: 100%" ></el-input>
                    </el-form-item>
                  </v-flex>
            </v-layout>

             <v-layout row v-if="this.prestataireSelect.type == 2" >
               <v-flex md3>
                <el-form-item label="Heure Début" required style="width:50%">
                  <el-time-select
                    v-model="prestataireSelect.heureDbtNuit"
                    @change="calculTotalComm1()"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:00'
                    }"
                    placeholder="Heure debut "
                  ></el-time-select>
                </el-form-item>
              </v-flex>

                <v-flex md3>
                <el-form-item label="Heure Fin" style="width:50%" required>
                  <el-time-select
                    v-model="prestataireSelect.heureFinNuit"
                    @change="calculTotalComm1()"
                    :picker-options="{
                       start: '00:00',
                        step: '00:15',
                        end: '05:00'
                    }"
                    placeholder="Heure fin "
                  ></el-time-select>
                </el-form-item>
              </v-flex>

                <v-flex md3>
                  <el-form-item label="Heure Pause" style="width:50%" required>
                    <el-time-select
                      v-model="prestataireSelect.heurePauseNuit"
                      @change="calculTotalComm1()"
                      :picker-options="{
                          start: '00:00',
                        step: '00:15',
                        end: '10:00'
                      }"
                      placeholder="Heure de pause "
                    ></el-time-select>
                  </el-form-item>
                </v-flex>

                  <v-flex md3>
                    <el-form-item label="Heure Intenperie" style="width:50%" required>
                      <el-time-select
                        v-model="prestataireSelect.heureIntemNuit"
                        @change="calculTotalComm1()"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '10:00'
                        }"
                        placeholder="Heure Intempéries "
                      ></el-time-select>
                    </el-form-item>
                  </v-flex>
                  <v-flex md3>
                    <el-form-item label="Total travail" style="width:100%" required>
                      <el-input  class="inline-input" v-model="prestataireSelect.heureTotalNuit" required  :placeholder="this.totalHeureOuvrierNuit" :readonly="true" style="width: 100%" ></el-input>
                    </el-form-item>
                  </v-flex>
            </v-layout>

            <!-- <v-layout row v-if="this.prestataireSelect.heurSUpp == 1" > -->

            <!-- </v-layout> -->

            <v-layout row  >
              <v-flex md3 v-if="this.prestataireSelect.heurSUpp == 1">
                <el-form-item label="Heure supplémentaire" required style="width:50%">
                  <el-time-select
                    v-model="prestataireSelect.heureSuppl"
                    @change="calculTotalComm()"
                    :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '08:00'
                    }"
                    placeholder="Heure supplémentaire "
                  ></el-time-select>
                </el-form-item>
              </v-flex>

               <v-flex md3 v-if="this.prestataireSelect.heurSUpp == 1">
                    <el-form-item style="width:100%" label="Description heure supplémentaire"  >
                        <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Description  " v-model="prestataireSelect.descriptionSupp"></el-input>
                    </el-form-item >
              </v-flex>
                <v-flex md4>
                      <el-form-item style="width:100%" label="Description"  >
                          <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Description  " v-model="prestataireSelect.description"></el-input>
                      </el-form-item >
                </v-flex>

                <v-flex md1>
                  <el-form-item label="Action">
                    <el-button type="primary" @click="addListPresence(prestataireSelect)">Ajouter</el-button>
                  </el-form-item>
                </v-flex>
          </v-layout>

          </el-form>
          <v-spacer></v-spacer>
          <br />

          <v-layout row class="ml-2 mr-2">
            <el-table :data="tablePresence" style="width: 100%">
              <el-table-column type="expand">
                  <template slot-scope="props">
                    <v-flex v-if=" props.row.heureSuppl != '00:00'">
                    <p>
                      <b>Heure supplémentaire</b>
                      : {{ props.row.heureSuppl }}
                    </p>
                    <p>
                      <b>Description heure supplémentaire</b>
                      : {{props.row.descriptionSupp}}
                    </p>
                    </v-flex>
                      <p>
                      <b>Description</b>
                      : {{ props.row.description }}
                    </p>
                  </template>
              </el-table-column>

              <el-table-column prop="nom" label="Nom" sortable></el-table-column>
              <el-table-column prop="libeleCont" label="contrat" sortable></el-table-column>
              <el-table-column prop="heureDbt" label="Heure de debut"></el-table-column>
              <el-table-column prop="heureFin" label="Heure de fin"></el-table-column>
              <el-table-column prop="heurePause" label="Heure Pause"></el-table-column>
              <el-table-column prop="heureIntem" label="Heure Intemperie"></el-table-column>
              <el-table-column prop="heureTotal" label="Total travail"></el-table-column>

              <el-table-column label="Operations">
                <template slot-scope="scope">
                  <v-tooltip top>
                    <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tablePresence)" dark>
                      <v-icon center>delete</v-icon>
                    </v-btn>Supprimer
                  </v-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </v-layout>
          <br />
        </v-card>
      <!-- </v-flex> -->

      <!-- bouton validation -->
    <!-- </v-layout> -->
    <!-- FIN ENREGISTRER UN PRESENCE -->
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { error } from 'util';

export default {
  components: { Loading },
  name: "ListePresence",
  props: {

  listeOuvriers: {
      type: Array
    },
  idTravaux:{
      type: Number
      }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      listePrestOuvriers: [],
      prestataireSelect: {
        id: null,
        contrat: null,
        heureDbt: null,
        heureDbtNuit: null,
        heureFin: null,
        heureFinNuit: null,
        heurePause: null,
        heurePauseNuit: null,
        heureIntem: null,
        heureIntemNuit: null,
        // heureNuit: null,
        description: null,
        depense: null,
        heureTotal: null,
        heureTotalNuit: null,
      },
       typeTravaiL: [
          { text: 'JOUR', value: 'JOUR',id: '1' },
          { text: 'NUIT', value: 'NUIT',id: '2' },
      ],
      heurSUpp: [
          { text: 'OUI', value: 'OUI',id: '1' },
          { text: 'NON', value: 'NON',id: '2' },
      ],
      totalPOuvrierHT : 0,
      totTTCOuvrireDepen: 0,
      totalHeureOuvrier: "",
      totalHeureOuvrierNuit: "",
      tablePresence: [],
      listeContratOuvrier:[],
      typePrestSelect: 0, //0=>ouvrier, 1=> prestataire
    };
  },

  watch: {},

  methods: {

    addListPresence(item) {

console.log('item',item)

      if (
        item.id == null ||
        item.id == "undefined" ||
        item.id.nom == null ||
        item.id.nom == "undefined"||
        item.heureDbt == "undefined" ||
        item.heureDbt == null ||
        item.heureFin == "undefined" ||
        item.heureFin == null ||
        item.heurePause == "undefined" ||
        item.heurePause == null ||
         item.heureIntem == "undefined" ||
        item.heureIntem == null ||
        item.contrat.idContrat == "undefined" ||
        item.contrat.idContrat == null ||
        item.heurSUpp == null ||
        item.heurSUpp == "undefined"
      ) {
        this.$message.error("Veuillez renseigner correctement les champs");
        return;
      }

        //verifions que l'ouvrier na deja pas ete selectionne
        let ouvrier = this.tablePresence.find( elt=>{
            return elt.nom == item.id.nom
        });

      if(ouvrier != undefined)
      {
          this.$message.warning("Cet ouvrier a déjà été selectionné");
          return;
      }

      if(item.type == 1){
      this.tablePresence.push({
        id: item.id.id ,
        nom:item.id.nom ,
        contrat: item.contrat.idContrat,
        libeleCont: item.contrat.libTache,
        heureDbt: item.heureDbt,
        heureFin: item.heureFin,
        heurePause: item.heurePause,
        heureIntem: item.heureIntem,
        heureSuppl: (item.heurSUpp == 2)?"00:00":heureSuppl,
        heureTotal: item.heureTotal,
        description: item.description,
        descriptionSupp: (item.heurSUpp == 2)?"":descriptionSupp,
        depense: item.depense,
        renumeration: item.renumeration
      });
      }else{
         this.tablePresence.push({
        id: item.id.id ,
        nom:item.id.nom ,
        contrat: item.contrat.idContrat,
        libeleCont: item.contrat.libTache,
        heureSuppl: (item.heurSUpp == 2)?"00:00":heureSuppl,
        heureDbt: item.heureDbtNuit,
        heureFin: item.heureFinNuit,
        heurePause: item.heurePauseNuit,
        heureIntem: item.heureIntemNuit,
        heureTotal: item.heureTotalNuit,
        description: item.description,
        descriptionSupp: (item.heurSUpp == 2)?"":descriptionSupp,
        depense: item.depense,
        renumeration: item.renumeration
      });
      }

       let tab = this.tablePresence
        let totalH = 0
        let totalQteCarbu = 0
        let totalCouCarbu = 0
        let totalMtanDepen = 0
      for (let index = 0; index < tab.length; index++) {

        const element = tab[index];
        let hr= this.TransFomrToMinut(element['heureTotal']);
        totalH += hr
        totalQteCarbu += element['qte'];
        totalMtanDepen += parseFloat(element['depense']);
        console.log('element',element)
      }
      this.totalPOuvrierHT = this.TransFomrToHeur(totalH)
      this.totTTCOuvrireDepen= totalMtanDepen


      this.prestataireSelect = {};
      this.$emit("dataChange", this.tablePresence)

    },
    TransFomrToMinut(item){
         let tabDateDbt = item.split(":"); //[00:00"]
         let hr = tabDateDbt[0];
         let min = tabDateDbt[1];
         let minute;

         minute = parseFloat(hr * 60 ) + parseFloat(min);
         return minute;
    } ,
    TransFomrToHeur(item){
         let heure;
         let minute;
         heure = Math.floor((item / 60));
         minute = parseFloat(item - (heure* 60));

         return (minute != 0)?heure+':'+minute:heure+':'+'00';
    } ,

  calculTotalComm()  {
    let maxDate = this.prestataireSelect.heureFin
    let minDate = this.prestataireSelect.heureDbt
     if(maxDate != null && minDate != null){

          let tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbt)
          let tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFin)
          let tabheurePause = this.TransFomrToMinut(this.prestataireSelect.heurePause)
          let tabheureIntem = this.TransFomrToMinut(this.prestataireSelect.heureIntem)
          // let tabheureNuit = this.TransFomrToMinut(this.prestataireSelect.heureNuit)
          let dureeMinute = tabheureFin - tabheureDbt;

          let TotalHeureTrav = parseFloat(tabheureFin) - parseFloat(tabheureDbt) - parseFloat(tabheurePause) - parseFloat(tabheureIntem);

          //on transforme ensuite les minutes en heures pour l'affichage
          this.prestataireSelect.heureTotal =  this.TransFomrToHeur(TotalHeureTrav)

          let totalHOuvri = this.prestataireSelect.heureTotal.split(":") //[00:00"]
          let montantOuvr = this.prestataireSelect.renumeration
          let HeurUtil = (totalHOuvri[0] + totalHOuvri[1]) / 100

          this.prestataireSelect.depense = parseInt(montantOuvr * HeurUtil)
          this.totalHeureOuvrier = this.TransFomrToHeur(TotalHeureTrav)
      }

},
 calculTotalComm1()
  {
      let minDate = this.prestataireSelect.heureDbtNuit.split(":")
      let maxDate = this.prestataireSelect.heureFinNuit.split(":")

      let tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbtNuit)
      let tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFinNuit)


        if(parseFloat(maxDate) > parseFloat(minDate)){

            let tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbtNuit)
            let tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFinNuit)
            let tabheurePause = this.TransFomrToMinut(this.prestataireSelect.heurePauseNuit)
            let tabheureIntem = this.TransFomrToMinut(this.prestataireSelect.heureIntemNuit)
            // let tabheureNuit = this.TransFomrToMinut(this.prestataireSelect.heureNuit1)
            let dureeMinute = tabheureFin - tabheureDbt;

            let TotalHeureTrav = parseFloat(dureeMinute)  - parseFloat(tabheurePause) - parseFloat(tabheureIntem);
              //on transforme ensuite les minutes en heures pour l'affichage
              this.prestataireSelect.heureTotalNuit =  this.TransFomrToHeur(TotalHeureTrav)

        }else{

              let tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbtNuit)
              let tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFinNuit)
              let tabheurePause = this.TransFomrToMinut(this.prestataireSelect.heurePauseNuit)
              let tabheureIntem = this.TransFomrToMinut(this.prestataireSelect.heureIntemNuit)
              let dureeMinute = tabheureFin + 1440 - tabheureDbt;

              let TotalHeureTrav = parseFloat(dureeMinute)  - parseFloat(tabheurePause) - parseFloat(tabheureIntem);

              //on transforme ensuite les minutes en heures pour l'affichage
              this.prestataireSelect.heureTotalNuit =  this.TransFomrToHeur(TotalHeureTrav)

              this.totalHeureOuvrierNuit = this.TransFomrToHeur(TotalHeureTrav)
            }
  },

  deleteRow(index, rows) {
          rows.splice(index, 1);
          this.$emit("dataChange", this.tablePresence)
           let tab = this.tablePresence
            let totalH = 0
            let totalQteCarbu = 0
            let totalCouCarbu = 0
            let totalMtanDepen = 0
          for (let index = 0; index < tab.length; index++) {

            const element = tab[index];
            let hr= this.TransFomrToMinut(element['heureTotal']);
            totalH += hr
            totalQteCarbu += element['qte'];
            totalMtanDepen += parseFloat(element['depense']);
            console.log('element',element)
          }
          this.totalPOuvrierHT = this.TransFomrToHeur(totalH)
          this.totTTCOuvrireDepen= totalMtanDepen
      },

      loadTacheOuvrier() {
          this.loading = true;
          console.log("prestataire select", this.prestataireSelect)
          let url = this.domaine + "ouvrier/"+this.prestataireSelect.id.id+"/idtravaux/"+this.idTravaux;
             this.$http.get(url).then(response => {
                if (response.body) {
                 console.log('response',response)
                  this.loading = false;
                  console.log("contratouvriers ", response.body);
                  this.listeContratOuvrier = response.body.contrats;
                }
              },
              response => {
                  this.loading = false;
                  console.log(" erreur chargment des taches de l'ouvriers", response.body);
              }
          )
      },

      handleChangeOuvrier(){
        console.log("ouvrierId", this.prestataireSelect)
        console.log("ouvrier", this.prestataireSelect['id']['id'])

            let libelle = this.prestataireSelect['id']['id']
              let resultat = 0
              // let details = this.listeOuvriers.forEach(element => {
                  let elementFound = this.listeOuvriers.find(prod => {
                   console.log("prod", prod)

                      return prod.id == libelle;
                    });
                    resultat = elementFound.montantNormal
              //   return elementFound.valeur
              // });
        this.prestataireSelect.renumeration = resultat
        console.log("resultat", resultat)


          this.loadTacheOuvrier()

      }


  },

  mounted() {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/boardTravaux/ListePresence.vue